import { useState } from 'react'

export const useAppointmentFilterHandlers = ({
  clinics,
  professionals,
  getProfessionals,
  initialLoadedKey = null,
  onSpecialityChange,
  onClinicChange
}) => {
  const [loadedProfessionalsKey, setLoadedProfessionalsKey] = useState(initialLoadedKey)
  const [isLoadingProfessionals, setIsLoadingProfessionals] = useState(false)

  const onChangeSpeciality = (speciality, setFieldValue, options = {}) => {
    const selectedSpecialities = Array.isArray(options.specialities)
      ? options.specialities
      : speciality
      ? [speciality]
      : []

    setLoadedProfessionalsKey(null)
    setFieldValue('speciality', speciality)
    setFieldValue('specialities', selectedSpecialities)
    setFieldValue('professional', null)
    setFieldValue('clinic', [])
    setFieldValue('clinicCode', [])

    if (onSpecialityChange) {
      onSpecialityChange({
        speciality,
        specialities: selectedSpecialities,
        professional: null,
        clinic: [],
        clinicCode: []
      })
    }
  }

  const onChangeClinic = (e, setFieldValue, speciality) => {
    const rawValue = e?.target?.value ?? e
    const clinicValues = Array.isArray(rawValue) ? rawValue : rawValue ? [rawValue] : []
    const clinicCodes = clinicValues
      .map(value => clinics.find(c => String(c.value) === String(value))?.codigoEmpresa)
      .filter(Boolean)

    setLoadedProfessionalsKey(null)
    setFieldValue('professional', null)
    setFieldValue('clinic', clinicValues)
    setFieldValue('clinicCode', clinicCodes)

    if (onClinicChange) {
      onClinicChange({ clinic: clinicValues, clinicCode: clinicCodes })
    }

    if (speciality && clinicCodes.length > 0) {
      getClinicOptions(clinicCodes, speciality)
    }
  }

  const getProfessionalsKey = (speciality, clinicCode) => {
    const codes = Array.isArray(clinicCode) ? clinicCode : clinicCode ? [clinicCode] : []

    return codes.length > 0 && speciality
      ? `${speciality}-${[...codes].sort().join(',')}`
      : null
  }

  const getClinicOptions = (clinicCode, speciality) => {
    const requestKey = getProfessionalsKey(speciality, clinicCode)

    if (!requestKey || isLoadingProfessionals) {
      return false
    }

    if (loadedProfessionalsKey === requestKey && professionals.length > 0) {
      return false
    }

    setIsLoadingProfessionals(true)

    Promise.resolve(getProfessionals(speciality, clinicCode))
      .then(() => {
        setLoadedProfessionalsKey(requestKey)
      })
      .finally(() => {
        setIsLoadingProfessionals(false)
      })

    return true
  }

  return {
    loadedProfessionalsKey,
    isLoadingProfessionals,
    onChangeSpeciality,
    onChangeClinic,
    getProfessionalsKey,
    getClinicOptions
  }
}
